/**
 * Laddar och validerar all balans-config för klienten.
 * Sim-koden tar emot färdig SimConfig — den importerar aldrig JSON själv.
 */
import unitsJson from '../config/units.json';
import countersJson from '../config/counters.json';
import matchJson from '../config/match.json';
import economyJson from '../config/economy.json';
import { loadConfig, type SimConfig } from './sim/config';

export function loadGameConfig(): SimConfig {
  return loadConfig({
    units: unitsJson,
    counters: countersJson,
    match: matchJson,
    economy: economyJson,
  });
}
